import React from "react";
import { Box } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import {
  MEET_OUR_TEAM,
  TECHNOLOGIES,
  LOGIN,
  REGISTRATION,
  VERIFY_OTP,
  LOGOUT,
  JOBS,
  APPLICATION_LIST,
  APPLICATION_DETAIL,
  CHAT_BOOKING,
  SET_PASSWORD,
  EMPLOYEE_PORTAL,
  CREATE_EMPLOYEE,
  EDIT_EMPLOYEE,
  SERVICES
} from "./Components/Routes";
import ApplicationList from "./Components/Application/ApplicationList";
import Registration from "./Components/Auth/Registration";
import VerifyOtp from "./Components/Auth/VerifyOtp";
import OurTeam from "./Components/OurTeams/OurTeam";
import JobList from "./Components/Job/JobList";
import Technologies from "./Components/Technologies/Techologies";
import ApplicationDetail from "./Components/Application/ApplicationDetail";
import Homepage from "./Components/Homepage";
import Navigation from "./Components/Navigations/Navigation";
import ChatBooking from "./Components/OurServices/ChatBooking/ChatBooking";
import ChatBookingDetail from "./Components/OurServices/ChatBooking/ChatBookingDetail";
import JobDetail from "./Components/Job/JobDetail";
import Login from "./Components/Auth/Login";
import Logout from "./Components/Auth/Logout";
import AlertBannerText from "./Components/Common/AlertBanner/AlertBanner";
import EmployeeList from "./Components/Employee/EmployeeList";
import EmployeeDetail from "./Components/Employee/EmployeeDetail";
import CreateEmployee from "./Components/Employee/CreateEmployee";
import SetPassword from "./Components/Auth/SetPassword";
import EditEmployee from "./Components/Employee/EditEmployee";
import TechnologyDetail from "./Components/Technologies/TechnologyDetail";
import Services from "./Components/OurServices/Services";

const App: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box"
      }}
    >
      <Navigation />
      <Box
        sx={{
          width: "100%",
          minHeight: "calc(100vh - 200px)",
          boxSizing: "border-box",
          padding: "2em"
        }}
      >
        <AlertBannerText />
        <Routes>
          <Route path={MEET_OUR_TEAM} element={<OurTeam />} />
          <Route path={TECHNOLOGIES} element={<Technologies />} />
          <Route path={LOGIN} element={<Login />} />
          <Route path={REGISTRATION} element={<Registration />} />
          <Route path={VERIFY_OTP} element={<VerifyOtp />} />
          <Route path={LOGOUT} element={<Logout />} />
          <Route path={CHAT_BOOKING} element={<ChatBooking />} />
          <Route
            path={`${CHAT_BOOKING}/:chatBookingId`}
            element={<ChatBookingDetail />}
          />
          <Route path={`${JOBS}/:jobId`} element={<JobDetail />} />
          <Route path={JOBS} element={<JobList />} />
          <Route path={`${APPLICATION_LIST}`} element={<ApplicationList />} />
          <Route
            path={`${APPLICATION_DETAIL}/:applicationId`}
            element={<ApplicationDetail />}
          />
          <Route path={`${EMPLOYEE_PORTAL}`} element={<EmployeeList />} />

          <Route
            path={`${EMPLOYEE_PORTAL}/:employeeId`}
            element={<EmployeeDetail />}
          />
          <Route
            path={`${EDIT_EMPLOYEE}/:employeeId`}
            element={<EditEmployee />}
          />
          <Route
            path={`${SET_PASSWORD}/:employeeId`}
            element={<SetPassword />}
          />
          <Route
            path={`${TECHNOLOGIES}/:technologyId`}
            element={<TechnologyDetail />}
          />
          <Route path={`${SERVICES}`} element={<Services />} />
          <Route path={`${TECHNOLOGIES}`} element={<Technologies />} />
          <Route path={`${CREATE_EMPLOYEE}`} element={<CreateEmployee />} />
          <Route path="/" element={<Homepage />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default App;
